import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireAuth({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <div className="page-loading">Checking session…</div>;
  }

  if (status === 'signed-out') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
